import * as React from 'react';
import './index.css';
import { buildUrl } from '@/utils/buildUrl';
import AdFlagContainer from '@/components/AdFlagContainer';
import { ShopStatus } from '@/components/HomePage/LandingPage/ItemCardV2/constan';
import { AdFlagExpKeyMap } from '@/components/AdFlagContainer/constant';
import { isSupportTransition } from '@/src/utils';
import { getAttachments } from '@/src/components/HomePage/ContentItems';
import { cloneDeep } from 'lodash';
import ImgOverlayView from '@components/HomePage/ImgOverlay';
import { getShopNameMaxLines } from '@/src/components/DynamicTag/utils';
import { HIT_AD } from '../../common/BaseComponent/adReport';
import ImgBottomLabel from '../../ImgBottomLabel';
import { ModuleLayoutInfo, ModuleItemJsonData } from '../../common/interface';
import BrandShopLogo from '../../common/LogoComponent';
import FeedsProductListComponent from '../../FeedsProductListComponent';
import { ContentSpecType } from '../../ContentItems/itemSuperCard/itemSuperCard';
import { reportBottomContentMC, reportBottomContentPV } from '../lxReport';

interface Props {
  cid?: string;
  dataId?: string;
  data: ModuleItemJsonData;
  lxReportOnClick?: Function;
  lxReportOnUnfoldButtonClick?: Function;
  isExpand: boolean | undefined; //是否展开了动态标签
  cardLayout?: ModuleLayoutInfo;
  indexPath?: any;
  longPressItemCard?: () => void;
}

interface State {
  bottomContentPVReported: boolean;
}

const WMRouter = Mach.requireModule('Router');
const { deviceModel } = Mach.env;
export default class FeedsGoldenShopCard extends React.PureComponent<Props, State> {
  sharedElementImageRef: any = null;

  constructor(props) {
    super(props);
    this.state = {
      bottomContentPVReported: false
    };
  }

  /**
   * 点击跳转进店铺
   * @param data
   */
  gotoDetailPage(data: any) {
    if (this.props.lxReportOnClick) {
      this.props.lxReportOnClick();
    }
    let shopInfoResponse = data?.shopInfoResponse;
    shopInfoResponse = { ...shopInfoResponse, checkList: !!shopInfoResponse };
    // todo: 验证user_get_mode
    const { shop_id, user_get_mode = 'delivery' } = data.logData;
    const hasTransitionPic = shopInfoResponse?.logoUrl;
    const supportTransition = isSupportTransition(Mach.env.bundleName) && hasTransitionPic;
    const transition = supportTransition ? 1 : 0;
    if (supportTransition) {
      this.sharedElementImageRef?.didSelectedImageView?.();
    }
    // 自提跳链
    WMRouter.navigateTo(buildUrl(data.scheme, { shop_id, user_get_mode, transition }), { shopInfoResponse }, () => { });
  }
  textLength = 0;

  render() {
    const { data } = this.props;
    return (
      <view
        className="root-container-home-page"
        style={{ flexDirection: 'column' }}
        onClick={() => {
          this.gotoDetailPage(data);
        }}
        onLongPress={this.props.longPressItemCard}
      >
        {this.renderGoldenCard()}
      </view>
    );
  }

  renderGoldenCard = () => {
    const { data } = this.props;
    const { user_get_mode = 'delivery' } = data.logData;
    const isPickUp = user_get_mode === 'pickup';
    const {
      shopStatus, imgTopContent: imgTopContentV1, imgTopContentV2, pictureBgInfo, imgBottomLabel, logo, imgOverlay
    } = data || {};
    // 样式兼容，优先使用v2的图片顶部标签
    const imgTopContent = imgTopContentV2 ? { ...imgTopContentV2, type: 'v2' } : (imgTopContentV1 ? { ...imgTopContentV1, type: 'v1' } : null);
    // 展示休息中
    const showRestBg = data?.shopStatus?.shopStatusCode === ShopStatus.CLOSED
      || data?.shopStatus?.shopStatusCode === ShopStatus.OFFLINE
      || data?.shopStatus?.shopStatusCode === ShopStatus.OUT_OF_RANGE;
    const hitAd = data?.adInfo?.hitAd === HIT_AD;
    // 广告标实验key
    const adFlagExpKey = data?.adInfo?.expKey;
    // 头图直出需要数据
    const shopHeadImageUrl = data?.shopInfoResponse?.logoUrl;
    const height = Math.floor(Number(Mach.env?.screenWidth) * (9 / 16));
    const shopHeadImageCacheCDNParam = `${Mach.env.screenWidth * Mach.env.scale}.${height * Mach.env.scale}.100`;
    const renderSharedElementImage = shopHeadImageUrl && isSupportTransition(Mach.env.bundleName);
    // 防止图片区域顶部标签与logo标签重叠，计算 (顶部标签左边距离 + 标签宽度) > (主图左边距 + 主图宽度 - logo右边距 - logo宽度)
    // true: 有重叠不展示

    let isLogoCollide = false;
    if (logo) {
      isLogoCollide = (imgTopContent && imgTopContent.width) ? (8 + Number(imgTopContent.width)) > (10 + 120 - 4 - 32) : true;
    }

    // 判断 bottomContent 是否有内容
    let hasBottomContent = false;
    if (data.bottomContent) {
      for (let i = 0; i < data.bottomContent.length; i++) {
        if (data.bottomContent[i].length > 0) {
          hasBottomContent = true;
          if (!this.state.bottomContentPVReported) {
            const logData = this.props?.data?.logData || {};
            reportBottomContentPV(logData);
            this.setState({ bottomContentPVReported: true });
          }
          break;
        }
      }
    }

    // 主图 背景图
    const {
      pic: { url = '' } = {}, // 为 pic 提供默认值 {}
      picRatio: { x = 1, y = 1 } = {} // 为 picRatio 提供默认值 {}
    } = pictureBgInfo || {};

    const picBgUrl = url;
    const picturePartWidth = 120;
    const picturePartHeight = picBgUrl ? (120 * y / x) : 120;

    return (
      <view className="itemContainer">
        <view style={{ flexDirection: 'column' }}>
          <view className="card-content-con">
            <view className="picturePart" style={{ width: picturePartWidth, height: picturePartHeight }}>
              {picBgUrl && (
                <image
                  className="picturePart-pic-bg"
                  resizeMode="aspectFill"
                  src={
                    picBgUrl
                  }
                />
              )}
              {renderSharedElementImage ? (
                <shared-element-image
                  ref={(ref) => {
                    this.sharedElementImageRef = ref;
                  }}
                  cdnOptimizationSize={shopHeadImageCacheCDNParam}
                  className="interactive-transition-image"
                  resizeMode="scaleToFill"
                  placeholder="assets://placeholder/icon_placeholder_16:9.png"
                  src={
                    shopHeadImageUrl
                  }
                  error="assets://placeholder/icon_placeholder_16:9.png"
                />
              ) : null}
              <image
                className="itemImage"
                resizeMode="aspectFill"
                placeholder="assets://placeholder/icon_placeholder_1:1.png"
                src={
                  data?.shopMainPicUrl !== null && data?.shopMainPicUrl !== ''
                    ? data?.shopMainPicUrl
                    : 'assets://placeholder/icon_placeholder_1:1.png'
                }
                error="assets://placeholder/icon_placeholder_1:1.png"
                // 用于修复安卓图片闪烁问题
                syncUpdate
              />
              {/* 品牌/商家logo */}
              { logo && <BrandShopLogo logo={logo} /> }
              {/* 广告标坑位 - 有腰封在腰封上方，没有在底部 */}
              {hitAd && AdFlagExpKeyMap.AD.has(adFlagExpKey) && (
                <view className="adFlagContainer-belt" style={{ bottom: (isPickUp || imgBottomLabel) ? 20 : 0 }}>
                  <AdFlagContainer adInfo={data?.adInfo} />
                </view>
              )}
              {/* 图片底部Tag */}
              {!showRestBg && imgBottomLabel && <ImgBottomLabel imgBottomLabel={imgBottomLabel} />}
              {/* 商家休息中蒙层 */}
              {(showRestBg || imgOverlay) && <ImgOverlayView shopStatus={shopStatus} imgOverlay={imgOverlay} />}
            </view>
            {/* 店铺信息 */}
            {this.renderContent(data)}
          </view>
          {hasBottomContent && (
            <view className="card-bottom-container">
              {this.renderBottomContent(data)}
            </view>
          )}
          {/* 图片区域顶部标签 */}
          {imgTopContent && !showRestBg && !isLogoCollide && (
            <image
              style={{ height: imgTopContent?.height }}
              className={imgTopContent.type === 'v2' ? 'brandPic-v2' : 'brandPic'} src={imgTopContent?.picUrl} resizeMode="heightFix" disableCdnOptimization={!!Mach.env.isAndroid}
            />
          )}
        </view>
        {/* 广告标坑位 - 暗点，商卡底部logo正下方 */}
        {hitAd && AdFlagExpKeyMap.DOT.has(adFlagExpKey) && (
          <view className="adFlagContainer-dot">
            <AdFlagContainer adInfo={data?.adInfo} />
          </view>
        )}

        {/* 广告标坑位 - 赞助，商卡右下角 */}
        {hitAd && AdFlagExpKeyMap.SPONSOR.has(adFlagExpKey) && (
          <view className="adFlagContainer-sponsor">
            <AdFlagContainer adInfo={data?.adInfo} />
          </view>
        )}
      </view>
    );
  }

  /**
   * 二维数组解析店铺信息
   * @param data
   * @returns
   */
  renderContent = (data: any) => {
    const { isExpand, indexPath } = this.props;
    const { content } = data;
    // 处理content数据，把门店标签和精选图标放进name的数据里面
    let featureValue; let
      pickUpIconValue;
    let modifiedContent = cloneDeep(content);
    // 计算卡片是否有展开收起样式数据
    const shouldShowMore = data.shouldShowMoreTags;
    // 含有子标题
    let hasSubCardTitle = false;
    let lastLine = 0;
    modifiedContent = modifiedContent.map((row: any[], line: number) => row.map((item) => {
      if (item.type === 'featureLabel') {
        featureValue = item.data.featureLabel;
      } else if (item.type === 'pickUpIcon') {
        pickUpIconValue = item.data.pickUpIcon;
      }
      if (item.type === 'shopName') {
        item.data.featureLabel = featureValue;
        item.data.pickUpIcon = pickUpIconValue;
      }
      if (item.type === 'subCardTitle' && line === 0) {
        hasSubCardTitle = true;
      }
      if (lastLine !== line && row.length > 0) {
        lastLine = line;
      }
      return item;
    }));
    const dynamicTagLineIndex = this.getDynamicTagLineIndex() > -1 ? this.getDynamicTagLineIndex() : undefined;
    return (
      <view style={{ marginLeft: 10, marginTop: -8, flexDirection: 'column' }}>
        {modifiedContent.length > 0 && (
          <view className="procuct-content-container">
            {modifiedContent.map((warp, line) => (warp?.length > 0 ? (
              <view key={line} className="procuct-content-item-container" style={{ marginRight: (line === dynamicTagLineIndex) ? (shouldShowMore ? 0 : 2) : 10, marginBottom: (lastLine === line ? 11 : 0) }}>
                {warp?.map((item, index) => {
                  const attachmentData = getAttachments(item);
                  if (attachmentData) {
                    const isDynamicTagsLine = item.type === 'dynamicTags';
                    const isShopNameLine = item.type === 'shopName';
                    let maxLines = 1;
                    if (isShopNameLine && !hasSubCardTitle) {
                    // 当有即将休息中的时候店铺名称最多展示1行
                      maxLines = getShopNameMaxLines(content);
                    } else if (isDynamicTagsLine) {
                    // 当动态标签展开时最大行数为0，否则根据动态标签上面的内容计算应该展示一行还是两行
                      maxLines = isExpand ? 0 : (data.isTwoLine ? 2 : 1);
                    }

                    // 首行有 shopName 和 子标题subCardTitle，子标题前要展示分割符
                    const specStyle = line === 0 && item?.type === 'shopName' && hasSubCardTitle ? { specType: ContentSpecType.Line, spec: 4 } : { specType: ContentSpecType.Point, spec: 4 };
                    const lastAttachmentData = getAttachments(warp?.[Number(index) + 1]);
                    return (
                      <view key={`item.type_${line}_${index}_view`} style={{ justifyContent: (isDynamicTagsLine && shouldShowMore) ? 'space-between' : 'flex-start', flexShrink: lastAttachmentData !== undefined ? 0 : 1 }}>
                        <attachmentData.attachment
                          key={`item.type_${line}_${index}`}
                          hasLastItem={lastAttachmentData !== undefined} // 必传
                          data={item?.data}
                          itemKey={item?.type}
                          style={{ maxLines }}
                          specStyle={specStyle}
                        />
                        {/* 动态标签的展开收起按钮 */}
                        {isDynamicTagsLine && shouldShowMore && !isExpand && (
                          <view
                            style={{ width: 36 }} hitSlop={{
                              top: 20, bottom: 20, left: 20, right: 20
                            }} onClick={() => {
                              this.props.lxReportOnUnfoldButtonClick?.(1);
                              globalThis.eventBus.publish('home-page-card-height-expand', { isExpand: true, indexPath });
                            }}
                          >
                            <image className="expand-icon-img" src="assets://homepage/golden-shopcard-arrow-down.png" />
                          </view>
                        )}
                        {isDynamicTagsLine && shouldShowMore && isExpand && (
                          <view
                            style={{ width: 36 }} hitSlop={{
                              top: 20, bottom: 20, left: 20, right: 20
                            }} onClick={() => {
                              this.props.lxReportOnUnfoldButtonClick?.(0);
                              globalThis.eventBus.publish('home-page-card-height-expand', { isExpand: false, indexPath });
                            }}
                          >
                            <image className="expand-icon-img" src="assets://homepage/golden-shopcard-arrow-up.png" />
                          </view>
                        )}
                      </view>
                    );
                  }
                  return null;
                })}
              </view>
            ) : null))}
          </view>
        )}
        {this.renderFeedsProductListComponent(data)}
      </view>
    );
  }

  // 菜品卡片
  renderFeedsProductListComponent = (data: any) => {
    const { subCards = [] } = data;
    return (subCards || []).length ? (
      <FeedsProductListComponent
        subCards={subCards}
        log_info={{ cid: this.props.cid, dataId: this.props.dataId }}
      />
    ) : null;
  }

  handleOnBottomContentClick() {
    const logData = this.props?.data?.logData || {};
    if (logData) {
      reportBottomContentMC(logData);
    } else {
      // TODO: 看下是否需要记录一下没有 logData 的场景？
    }
  }

  renderBottomContent = (data: any) => {
    const { bottomContent } = data;
    // 处理content数据，把门店标签和精选图标放进name的数据里面
    let featureValue;
    let pickUpIconValue;
    let modifiedContent = cloneDeep(bottomContent);
    // 计算卡片是否有展开收起样式数据
    modifiedContent = modifiedContent.map((row: any[]) => row.map((item) => {
      if (item.type === 'featureLabel') {
        featureValue = item.data.featureLabel;
      } else if (item.type === 'pickUpIcon') {
        pickUpIconValue = item.data.pickUpIcon;
      }
      if (item.type === 'shopName') {
        item.data.featureLabel = featureValue;
        item.data.pickUpIcon = pickUpIconValue;
      }
      return item;
    }));
    return (
      <view style={{ marginTop: -8 }}>
        {modifiedContent.length > 0 && (
          <view className="procuct-content-container">
            {modifiedContent.map((warp, line) => (warp?.length > 0 ? (
              <view key={line} className="procuct-content-item-container" style={{ marginRight: 10 }}>
                {warp?.map((item, index: number) => {
                  const attachmentData = getAttachments(item);
                  if (attachmentData) {
                    const isDynamicTagsLine = item.type === 'dynamicTags';
                    let maxLines = 1;
                    if (isDynamicTagsLine) {
                      // 动态标签底部暂不支持折叠
                      maxLines = 0;
                    }
                    const marginBottom = isDynamicTagsLine ? 11 : 0;
                    const lastAttachmentData = getAttachments(warp?.[index + 1]);
                    return (
                      <view key={`item.type_${line}_${index}_view`} style={{ justifyContent: 'flex-start', marginBottom, flexShrink: lastAttachmentData !== undefined ? 0 : 1 }}>
                        <attachmentData.attachment
                          customHandleOnTagClick={this.handleOnBottomContentClick.bind(this)}
                          key={`item.type_${line}_${index}`}
                          hasLastItem={lastAttachmentData !== undefined} // 必传
                          data={item?.data}
                          itemKey={item?.type}
                          style={{ maxLines }}
                        />
                      </view>
                    );
                  }
                  return null;
                })}
              </view>
            ) : null))}
          </view>
        )}
      </view>
    );
  }

  /**
   * 计算动态标签所在的行数
   * @returns
   */
  getDynamicTagLineIndex = () => {
    const { data } = this.props;
    const hasDynamicTag = data.content.some((subArray) => subArray.some((item) => item.type === 'dynamicTags'));
    if (!hasDynamicTag) {
      return -1;
    }
    // 存储dynamicTags元素的索引
    let dynamicTagsIndex = data.content.length - 1;
    // 遍历二维数组，找到dynamicTags元素的索引
    data.content.forEach((row, rowIndex) => {
      if (rowIndex) {
        row.forEach((item) => {
          if (item.type === 'dynamicTags') {
            const arrLength = data.content[rowIndex].length;
            // 说明当前这行只有动态标签
            if (arrLength === 1) {
              dynamicTagsIndex = rowIndex;
            }
          }
        });
      }
    });
    return dynamicTagsIndex;
  }
}
